<template>
  <div class="position-top empty-site">
    <wownow-image src="https://img.tinhnow.com/wownow/files/pro/app/MEF/BF/BD/1b9d6ff4b6924eefaff2c00829d1555b.png" class="empyt" />
    <div class="empyt-txt">{{ $t('global.gameOver') }}</div>
    <EmptyButton @click="btnClick" />
  </div>
</template>

<script>
import EmptyButton from './empty-button';
export default {
  components: {EmptyButton},
  methods: {
    btnClick() {
      Vue.filter('go-h5')('superapp://SuperApp/YumNow');
      try {
        window.WOWNOW.closeWindow();
      } catch(err) {}
    }
  }
}
</script>

<style lang="stylus" scoped>
  .empty-site {
    width: 100%;
    top: 108px;
    text-align: center;
  }
  .empyt {
    width: 200px;
    margin: 0 auto;
  }
  .empyt-txt {
    width: 100%;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 20px;
    padding-top: 16px;
    padding-bottom: 40px;
  }
</style>